module.exports = __webpack_public_path__ + "static/media/logo_login.30ca6ed5.png";